import { connect } from 'react-redux';
import { pushUserSymbolsPopup } from '../../../UserSymbolsPopup/actions';
const mapDispatchToProps = {
    pushUserSymbolsPopup
};
export default connect(undefined, mapDispatchToProps);

//# sourceMappingURL=UserSymbol.container.js.map